import { Card, Avatar, Typography, Space } from "antd";
import { useSessionGuest } from "../../hooks/useSession";
import { useImageSrc } from "../../hooks/useImage";
import SessionDateDisplay from "./SessionDateDisplay";
import SessionActions from "./SessionActions";

const SessionCard = ({ sessionDetails }) => {
  const session = sessionDetails?.session,
    attendees = sessionDetails?.attendees;
  const guest = useSessionGuest(attendees);
  const guestAvatar = useImageSrc(guest?.Avatar);

  return (
    <Card style={{ textAlign: "center", marginTop: "50px" }}>
      <Avatar
        src={guestAvatar}
        icon={guest?.FirstName.substring(0, 1)}
        shape="square"
        size={100}
      />
      <Typography.Title
        level={5}
        style={{ marginBottom: "0" }}
      >{`${session?.Category} Session`}</Typography.Title>
      <Typography.Title level={5} type="secondary" style={{ marginTop: "0" }}>
        with {guest?.FirstName}
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        {session?.Note}
      </Typography.Paragraph>
      <Space direction="vertical">
        <SessionDateDisplay session={session} />
        <SessionActions session={session} guestUser={guest} />
      </Space>
    </Card>
  );
};

export default SessionCard;
